import { Box, Skeleton } from '@mui/material';
import React from 'react';
import moment from 'moment';
import { useQuery } from '@tanstack/react-query';

import { getPatientMedicines } from 'app/services/patient';
import { EmptyState } from 'app/shared-components/common';

export default function PatientTab(props) {
  const { patientId } = props;

  const { data: patientsMedicines, isFetched } = useQuery({
    queryKey: ['patientMedicines', patientId],
    queryFn: () => getPatientMedicines({ patientId, options: { dependents: false } }),
    enabled: Boolean(patientId),
    meta: { errorMessage: 'Failed to fetch patient medicines' },
    refetchOnWindowFocus: false,
  });

  const patientMedicines = isFetched && patientsMedicines?.[0];

  return (
    <Box className="grid grid-cols-[auto_240px_200px] grid-rows-[48px_repeat(10,_min-content)] [&>*]:p-14 text-grey-700 overflow-y-auto">
      <HeaderCell>Medicine name</HeaderCell>
      <HeaderCell>Last ordered</HeaderCell>
      <HeaderCell>Repeat cycle</HeaderCell>
      {isFetched &&
        patientMedicines?.medicines?.length > 0 &&
        patientMedicines.medicines.map((medicine) => (
          <React.Fragment key={medicine._id}>
            <Box>{medicine.medicine_name}</Box>
            <Box>
              {medicine.last_order_date
                ? `Ordered ${moment.unix(medicine.last_order_date).fromNow()}`
                : '-'}
            </Box>
            <Box>
              {medicine.repeat_cycle ? `Repeat - ${medicine.repeat_cycle} day Cycle` : 'As Needed'}
            </Box>
          </React.Fragment>
        ))}
      {isFetched && patientMedicines?.medicines?.length === 0 && (
        <EmptyState title="Patient has not added any medicines yet" subtitle={null} />
      )}
      {!isFetched && <LoadingState rows={6} />}
    </Box>
  );
}

const HeaderCell = ({ children }) => (
  <Box className="flex items-center sticky top-0 bg-white font-500 text-14 text-grey-40 z-10 border-b-1 border-border">
    {children}
  </Box>
);

const LoadingState = ({ rows }) => (
  <>
    {Array.from({ length: rows }).map((_, index) => (
      <React.Fragment key={index}>
        <Box>
          <Skeleton variant="text" width="350px" />
        </Box>
        <Box>
          <Skeleton variant="text" width="150px" />
        </Box>
        <Box>
          <Skeleton variant="text" width="120px" />
        </Box>
      </React.Fragment>
    ))}
  </>
);
